import type { InterviewOutcomeState } from '../hooks/use-briefs'

type OutcomeBadgeVariant = 'secondarySoft' | 'successSoft' | 'destructiveSoft' | 'defaultSoft' | 'matchMixed'

export type InterviewOutcomeOption = {
  value: InterviewOutcomeState
  label: string
  description: string
  badgeVariant: OutcomeBadgeVariant
}

/** Display order matches the recruiter flow: scheduled → passed/failed → hired/not progressed. */
export const INTERVIEW_OUTCOME_OPTIONS: readonly InterviewOutcomeOption[] = [
  {
    value: 'scheduled',
    label: 'Interview scheduled',
    description: 'An interview is booked with the client.',
    badgeVariant: 'secondarySoft',
  },
  {
    value: 'passed',
    label: 'Passed interview',
    description: 'The client wants to progress this candidate.',
    badgeVariant: 'successSoft',
  },
  {
    value: 'failed',
    label: 'Failed interview',
    description: 'Not progressing after interview — add why in notes.',
    badgeVariant: 'destructiveSoft',
  },
  {
    value: 'hired',
    label: 'Hired',
    description: 'Offer accepted; placement made.',
    badgeVariant: 'defaultSoft',
  },
  {
    value: 'not_progressed',
    label: 'Not progressed',
    description: 'Did not reach interview or withdrew.',
    badgeVariant: 'matchMixed',
  },
]

export function interviewOutcomeOption(state: InterviewOutcomeState | null | undefined) {
  return INTERVIEW_OUTCOME_OPTIONS.find((option) => option.value === state) ?? null
}

export function interviewOutcomeBadgeVariant(state: InterviewOutcomeState | null | undefined): OutcomeBadgeVariant {
  return interviewOutcomeOption(state)?.badgeVariant ?? 'secondarySoft'
}

export function interviewOutcomeLabel(state: InterviewOutcomeState | null | undefined, fallback = 'No outcome yet') {
  return interviewOutcomeOption(state)?.label ?? fallback
}
